import { IEnvironment } from '@pulse/util/environment';

export const environment: IEnvironment = {
  production: true,
  offline: false,
  server: {},
  title: 'Pulse.Cloud Infrastructure',
  authconfig: {},
};
